import React from 'react';
import styled from 'styled-components/macro';

import IconBarArrow from '@mirinae/lessons/components/lesson/icons/IconBarArrow';
import IconReplay from '@mirinae/lessons/components/lesson/icons/IconReplay';
import { lessonsPalette, zIndex } from '@mirinae/lessons/modules/defines/styles';
import { LessonButton } from '@mirinae/lessons/modules/defines/styles';

const StepperButtonWrapper = styled(LessonButton)`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${props => (props.state === 'active' ? lessonsPalette.default[0] : lessonsPalette.primary.white)};
    box-shadow: 0 0 10px rgba(134, 134, 134, 0.25);
    z-index: ${zIndex.float};
    svg {
        vertical-align: middle;
    }
    .icon-arrow path {
        fill: ${props => (props.state === 'active' ? lessonsPalette.primary.white : lessonsPalette.default[0])};
    }
    .icon-relay path {
        stroke: ${props => (props.state === 'active' ? lessonsPalette.primary.white : lessonsPalette.default[0])};
    }
    :disabled {
        background-color: ${props => (props.state === 'active' ? lessonsPalette.grey[5] : lessonsPalette.primary.white)};
        .icon-arrow path {
            fill: ${props => (props.state === 'active' ? lessonsPalette.primary.white : lessonsPalette.grey[5])};
        }
        .icon-relay path {
            stroke: ${props => (props.state === 'active' ? lessonsPalette.primary.white : lessonsPalette.grey[5])};
        }
    }
    :hover:not(:disabled) {
        box-shadow: 0 0 7px rgba(161, 205, 207, 0.7);
        background-color: ${props => (props.state === 'active' ? lessonsPalette.darken[0] : lessonsPalette.default[0])};
        .icon-arrow path {
            fill: ${lessonsPalette.primary.white};
        }
        .icon-replay path {
            stroke: ${lessonsPalette.primary.white};
        }
    }
    ${props => (props.hover && `
        box-shadow: 0 0 7px rgba(161, 205, 207, 0.7);
        background-color: ${props.state === 'active' ? lessonsPalette.darken[0] : lessonsPalette.default[0]};
        .icon-arrow path {
            fill: ${lessonsPalette.primary.white};
        }
        .icon-replay path {
            stroke: ${lessonsPalette.primary.white};
        }
    `)}
    ${props => (props.icon === 'next' && `
        .icon-arrow {
            transform: rotate(180deg);
        }
    `)}
`;

const StepperButton = props => (
    <StepperButtonWrapper type="button" {...props}>
        {props.icon === 'replay' ? <IconReplay className="icon-replay" /> : <IconBarArrow className="icon-arrow" />}
    </StepperButtonWrapper>
);

export default StepperButton;